var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnewaytripicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 13.5338L12 10.5252L9.00002 7.51672",
    fill: "#E1F4D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 13.5338L12 10.5252L9.00002 7.51672",
    stroke: "#315E45",
    strokeWidth: 1.27841,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.71118 21 0 16.2888 0 10.5C0 4.71119 4.71118 0 10.5 0C16.2888 0 21 4.71119 21 10.5C21 16.2888 16.2888 21 10.5 21ZM10.5 1.10526C5.31908 1.10526 1.10526 5.31908 1.10526 10.5C1.10526 15.6809 5.31908 19.8947 10.5 19.8947C15.6809 19.8947 19.8947 15.6809 19.8947 10.5C19.8947 5.31908 15.6809 1.10526 10.5 1.10526Z",
    fill: "#315E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnewaytripicon);
export default __webpack_public_path__ + "static/media/onewaytripicon.7b4123ac36255ca1b0e04d802bd25872.svg";
export { ForwardRef as ReactComponent };